import { render } from "./SurveyQuestion2.vue?vue&type=template&id=263c10dd"
import script from "./SurveyQuestion2.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion2.vue?vue&type=script&lang=js"

import "./SurveyQuestion2.vue?vue&type=style&index=0&id=263c10dd&lang=css"

import exportComponent from "/home/danujaf/development/customer-survey/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__